module.exports = __webpack_public_path__ + "img/T2D_rc_10.4767482d.png";